const ROUTE_PATH = {
  PAGE404: '*',
  UN_AUTH: '/unauthorised',
  HOME: '/prosure',
  VERIFY_OTP: '/prosure/verify-otp',
  SUCCESS_OTP: '/prosure/otp-verified',
  FAILURE_OTP: '/prosure/otp-unverified',
  CUSTOMER_DETAILS: '/prosure/customer-details',
  SUCCESS_PAYMENT: '/prosure/payment-success',
  FAILURE_PAYMENT: '/prosure/payment-failed',
  PAYMENT: '/prosure/payment'
};

export default ROUTE_PATH;
